<template>
  <div id="nav">
      <span class="nav-prompt">$</span>
      <a href="https://github.com/jordicea" target="_blank">github</a>
      <a href="https://www.linkedin.com/in/jordicea" target="_blank">linkedin</a>
  </div>
</template>

<script style="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class MenuNav extends Vue {}
</script>
